import React from "react";
import cn from "classnames";

import { useAppSelector } from "@/redux/store";
import { selectAuthBgImages } from "@/util/selectors";
import { isTabletView } from "@/util";

import "./style.scss";

type Props = {
  className?: string;
  children: React.ReactNode;
  signUp?: boolean;
};

const AuthWebLayout: React.FC<Props> = ({
  className,
  children,
  signUp = false
}) => {
  const { signInPageTopBg, signUpPageTopBg } =
    useAppSelector(selectAuthBgImages);
  const bgImage = signUp ? signUpPageTopBg : signInPageTopBg;

  return (
    <div
      className={cn("root_auth_web_layout", className, {
        tabletView: isTabletView
      })}
    >
      <header className="heroWeb">
        {bgImage && (
          <img
            src={bgImage}
            alt="Smile More Loyalty Program"
            className="heroWebImage"
            style={{ maxWidth: 450 }}
          />
        )}
      </header>

      <main className="authWebCard" role="main">
        {children}
      </main>
    </div>
  );
};

export default AuthWebLayout;
